import { Record } from 'immutable';

const TaskStatisticRecord = Record({
  taskStatusCode: undefined,
  taskCount: undefined,
});

class TaskStatistic extends TaskStatisticRecord { }

TaskStatistic.create = (data) => new TaskStatistic(data);

export default TaskStatistic;



// WEBPACK FOOTER //
// ./data/Tasks/TaskStatistic/model.js